/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

interface Props {
  children: React.ReactNode
  backgroundUrl: any
}

const ScreenContainerWithBackgroundWrapper = ({
  children,
  backgroundUrl,
}: Props) => {
  return (
    <div
      className="screen-container__wrapper-with-cover-bg"
      style={{
        backgroundColor: '#f4f6fb',
        backgroundImage: `url(${backgroundUrl.default})`,
        backgroundPosition: 'center center',
      }}
    >
      {children}
    </div>
  )
}

export default ScreenContainerWithBackgroundWrapper
